import { MenuItem, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Link as RouterLink } from 'react-router-dom';
import { RootState } from "../store";

export default function MainNavigationItemMobile(params: { name: string, path: string, callback: () => void }) {
    // Check if navigation item is active and change color accordingly
    const nav = useSelector((state: RootState) => state.navigation.value);
    const active = (params.path.startsWith(nav));
    let col = "black";
    if (active) col = "#b7979c";

    return (
        <MenuItem dense onClick={params.callback} component={RouterLink} to={"/" + params.path}
            sx={{ ':hover': { bgcolor: 'kr.main' }, color: col, margin: "0px", textTransform: 'none' }}>
            <Typography variant="subtitle1" sx={{ margin: 0, padding: 0 }}>
                {params.name}
            </Typography>
        </MenuItem>
    );
}